module.exports = __webpack_public_path__ + "img/equipos-de-sala-img-2.e58e99e6.jpg";